export enum QuestionType {
    cityImage = 0,
    vocabulary = 1,
    other = 99
}



// WEBPACK FOOTER //
// ./src/app/enums/question.type.enum.ts